<!-- =========================================================================================
  File Name: UserEdit.vue
  Description: User Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <vcl-facebook secondary="#ff9f43" v-if="loading"></vcl-facebook>
    <div v-if="!loading">
      <vx-card class="mb-base">
        <div class="vx-row mb-5 ml-0">
          <vs-button
            id="back"
            size="small"
            icon-pack="feather"
            icon="icon-skip-back"
            color="success"
            class="mr-4"
            type="border"
            :to="{
              name: 'contactsView',
              params: { contactsId: editSelectedRowData.customerId },
            }"
          ></vs-button>
          <label for="back" class="mt-1">
            <b>Geri</b>
          </label>
        </div>

        <div class="vx-row">
          <div class="vx-col w-1/2">
            <div class="flex items-start flex-col sm:flex-row">
              <img :src="picture ? picture : this.$defaultPicture" class="mr-8 rounded h-24 w-24" />
              <div>
                <p class="text-lg font-medium mb-2 mt-4 sm:mt-0" :class="editSelectedRowData.firstName_span ? 'bg-warning p-3' : ''">
                  Adı Soyadı:
                  <span v-html="editSelectedRowData.firstName"></span> #{{ editSelectedRowData.customerId }}
                  <span v-if="editSelectedRowData.firstName_span" class="danger"><b>&nbsp;(Kendisiyle iletişim kurulmasını istemiyor)</b></span>
                </p>
                <input type="file" class="hidden" ref="update_avatar_input" @change="update_avatar" accept="image/*" />

                <vs-button size="small" class="mr-4 mb-4" @click="$refs.update_avatar_input.click()">Foto Değiştir</vs-button>
                <vs-button size="small" type="border" color="danger">Foto Sil</vs-button>
              </div>
            </div>
          </div>
          <div class="vx-col w-1/2">
            <!-- <label class="text-sm">Müşteri Yıldızları:</label>
          <star-rating
            @rating-selected="setRating"
            v-model="editSelectedRowData.personalStar"
            :star-size="20"
            ></star-rating>-->
          </div>
        </div>
        <!-- Content Row -->

        <div class="vx-row">
          <div class="vx-col md:w-1/4 w-full">
            <vs-input size="small" class="w-full mt-4" label="Adı Soyadı" v-model="editSelectedRowData.firstName" v-validate="'required'" name="username" />
            <span class="text-danger text-sm" v-show="errors.has('username')">{{ errors.first("username") }}</span>
          </div>
          <div class="vx-col md:w-1/4 w-full">
            <vs-input size="small" class="w-full mt-4" label="Telefon" v-model="editSelectedRowData.phone" v-validate="'numeric'" name="phone" />
            <span class="text-danger text-sm" v-show="errors.has('editSelectedRowData.phone')">{{ errors.first("this.editSelectedRowData.phone") }}</span>
          </div>

          <div class="vx-col md:w-1/4 w-full">
            <vs-input size="small" class="w-full mt-4" label="E-Posta" v-model="editSelectedRowData.email" type="email" v-validate="'email'" name="email" />
            <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first("email") }}</span>
          </div>

          <div class="vx-col md:w-1/4 w-full" v-if="$store.state.userData.authorizationList.find((f) => f.authorizationId == '12') != null">
            <vs-input size="small" class="w-full mt-4" label="Limit" v-model="editSelectedRowData.limit" type="number" name="limit" />
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col md:w-1/3 w-full">
            <div class="mt-4">
              <label class="vs-input--label">Ülke</label>
              <v-select class="style-chooser" v-model="selectedCountry" :options="countries" :clearable="false" v-validate="'required'" label="value" name="region" placeholder="Ülke Seçin" :searchable="false" @input="cityConfiguraition">
                <span slot="no-options">Eşleşen Veri Yok</span>
              </v-select>
              <span class="text-danger text-sm" v-show="errors.has('region')">{{ errors.first("region") }}</span>
            </div>
          </div>

          <div class="vx-col md:w-1/3 w-full">
            <div class="mt-4">
              <label class="vs-input--label">İl</label>
              <v-select class="style-chooser" v-model="selectedCity" :clearable="false" :options="tempcities" :searchable="false" label="value" v-validate="'required'" name="cities" placeholder="İl Seçin" @input="countyConfiguraition">
                <span slot="no-options">Eşleşen Veri Yok</span>
              </v-select>
              <span class="text-danger text-sm" v-show="errors.has('cities')">{{ errors.first("cities") }}</span>
            </div>
          </div>

          <div class="vx-col md:w-1/3 w-full">
            <div class="mt-4">
              <label class="text-sm">İlçe</label>
              <v-select class="style-chooser" v-model="selectedCounty" :clearable="false" :searchable="false" label="value" :options="tempcounties" name="counties" placeholder="İlçe Seçin">
                <span slot="no-options">Eşleşen Veri Yok</span>
              </v-select>
              <span class="text-danger text-sm" v-show="errors.has('counties')">{{ errors.first("counties") }}</span>
            </div>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col md:w-1/3 w-full">
            <div class="mt-4">
              <label class="text-sm">Etiketler</label>
              <v-select class="style-chooser" v-model="editSelectedRowData.tagsNew" multiple :closeOnSelect="false" :options="customerTags" label="value" name="customerTagname" placeholder="Etiket Seçin">
                <span slot="no-options">Eşleşen Veri Yok</span>
              </v-select>
            </div>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <vs-input size="small" class="w-full mt-4" label="Telefon(2)" v-model="editSelectedRowData.phone2" v-validate="'numeric'" name="phone2" />
            <span class="text-danger text-sm" v-show="errors.has('editSelectedRowData.phone2')">{{ errors.first("this.editSelectedRowData.phone2") }}</span>
          </div>

          <div class="vx-col md:w-1/3 w-full">
            <div class="mt-4">
              <vs-input size="small" class="w-full mt-4" label="Bölge seçin" v-model="editSelectedRowData.detailNote" name="detailNote" />
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-1/3 w-full">
            <div class="mt-4">
              <label class="text-sm">Vergi Dairesi</label>
              <v-select class="style-chooser" v-model="editSelectedRowData.taxOffice" :options="taxOfficeList" label="value" placeholder="Vergi Dairesi Seçin" :reduce="(taxOfficeList) => taxOfficeList.id" name="taxOfficeList">
                <span slot="no-options">Eşleşen Veri Yok</span>
              </v-select>
              <span class="text-danger text-sm" v-show="errors.has('taxOfficeList')">{{ errors.first("taxOfficeList") }}</span>
            </div>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <vs-input size="small" class="w-full mt-4" label="Müşteri Vergi No" v-model="editSelectedRowData.taxNumber" v-validate="'numeric'" name="taxNumber" />
            <span class="text-danger text-sm" v-show="errors.has('taxNumber')">{{ errors.first("taxNumber") }}</span>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <div class="vx-row mt-8">
              <div class="vx-col w-1/2">
                <vs-checkbox v-model="editSelectedRowData.isOnlineCustomer">Pazaryeri müşterisi</vs-checkbox>

                <span class="text-danger text-sm" v-show="errors.has('taxNumber')">{{ errors.first("taxNumber") }}</span>
              </div>
              <div class="vx-col w-1/2">
                <vs-checkbox v-model="editSelectedRowData.isSupplier">Tedarikçi</vs-checkbox>
                <!-- en sağdakı bos yarım -->
              </div>
            </div>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col md:w-1/3 w-full">
            <vs-textarea height="20px" class="w-full mt-4" label="Teslimat Adresi" v-model="editSelectedRowData.address" v-validate="'required'" name="deliveryAddress" />
            <span class="text-danger text-sm" v-show="errors.has('deliveryAddress')">{{ errors.first("deliveryAddress") }}</span>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <vs-textarea height="200px" class="w-full mt-4" label="Fatura Adresi" v-model="editSelectedRowData.billingAddress" v-validate="'required'" name="billingAddress" />
            <span class="text-danger text-sm" v-show="errors.has('billingAddress')">{{ errors.first("billingAddress") }}</span>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <vs-textarea height="20px" class="w-full mt-4" label="Müşteri Yorum" v-model="editSelectedRowData.comment" v-validate="'required'" name="comment" />
            <span class="text-danger text-sm" v-show="errors.has('comment')">{{ errors.first("comment") }}</span>
          </div>
        </div>

        <!-- Save & Reset Button -->
        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="mt-1 flex flex-wrap items-center justify-end">
              <vs-button size="small" class="ml-auto mt-2" @click="save_changes" :disabled="!validateForm">Kaydet</vs-button>
              <vs-button size="small" class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Vazgeç</vs-button>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { repository } from "@/_services/repository.js";
import vSelect from "vue-select";
import StarRating from "vue-star-rating";
import { Validator } from "vee-validate";
import { VclFacebook } from "vue-content-loading";
const dict = {
  custom: {
    username: {
      required: "Ad soyad zorunludur!",
    },
    phone: {
      required: "Telefon zorunludur!",
      numeric: "Telefon numarası sadece rakamlardan oluşabilir",
    },
    email: {
      email: "Email adresi ornek@ornek.com şeklinde olmalıdır!",
    },
    region: {
      required: "Ülke seçimi zorunludur!",
    },
    cities: {
      required: "İl seçimi zorunludur!",
    },
    counties: {
      required: "İlçe seçimi zorunludur!",
    },

    phone2: {
      numeric: "Telefon numarası sadece rakamlardan oluşabilir",
    },
    taxNumber: {
      numeric: "Vergi numarası sadece rakamlardan oluşabilir",
    },
  },
};
Validator.localize("tr", dict);

export default {
  components: {
    vSelect,
    StarRating,
    VclFacebook,
  },
  data() {
    return {
      loadController: [],
      loading: true,
      editSelectedRowData: {},
      countries: [],
      cities: [],
      counties: [],
      tempcities: [],
      tempcounties: [],
      customerTags: [],
      taxOfficeList: [],
      selectedCountry: {},
      selectedCity: {},
      selectedCounty: {},

      picture: null,
      statusOptions: [
        { label: "Çalışıyor", value: "true" },
        { label: "Ayrıldı", value: "false" },
      ],
      roleOptions: [
        { label: "Admin", value: "admin" },
        { label: "Kullanıcı", value: "user" },
      ],
    };
  },
  computed: {
    validateForm() {
      return !this.errors.any();
    },
    countrySelector() {
      if (this.countries) return this.countries.find((x) => x.id == this.editSelectedRowData.billingCountry);
    },
    citySelector() {
      if (this.cities) return this.cities.find((x) => x.id == this.editSelectedRowData.billingCity);
    },
    countySelector() {
      if (this.counties) return this.counties.find((x) => x.id == this.editSelectedRowData.billingCounty);
    },
  },
  created: async function() {
    await this.fetchCustomerData();
    let [a, b, c, d, e] = await Promise.all([this.getCountries(), this.getCities(), this.getCounties(), this.taxOffices(), this.getCustomerTags()]);

    this.loading = false;
    if (!a || !b || !c || !d || !e) {
      this.$vs.notify({
        title: "Hata",
        text: "Bağlantı hatası",
        color: "danger",
      });
    }
  },
  methods: {
    //ülke değiştirilirse
    cityConfiguraition() {
      this.selectedCity = "";
      this.selectedCounty = "";
      this.tempcities = this.cities.filter((x) => x.countryId == this.selectedCountry.id);
    },
    //il değiştirilirse
    countyConfiguraition() {
      this.selectedCounty = "";
      this.tempcounties = this.counties.filter((x) => x.cityId == this.selectedCity.id);
    },
    //tüm ülkerelerin çekilmesi ve seçili ülkenin bulunması
    getCountries: async function() {
      this.countries = await repository.getAll("General/getCountries").then((r) => r.list);
      this.selectedCountry = this.countrySelector;
      if (this.selectedCountry) this.loadController.push("ülkeler");
      return this.countries;
    },
    //tüm iller çekilmesi ve seçili ülkenin bulunması
    getCities: async function() {
      this.cities = await repository.getAll("General/getCities").then((r) => r.list);

      this.selectedCity = this.citySelector;
      this.tempcities = this.cities.filter((x) => x.countryId == this.editSelectedRowData.billingCountry);
      if (this.tempcities) this.loadController.push("iller");
      return this.cities;
    },
    //tüm ilçeler çekilmesi ve seçili ülkenin bulunması
    getCounties: async function() {
      this.counties = await repository.getAll("General/getCounties").then((r) => r.list);

      this.selectedCounty = this.countySelector;

      this.tempcounties = this.counties.filter((x) => x.cityId == this.editSelectedRowData.billingCity);
      if (this.tempcounties) this.loadController.push("ilçeler");
      return this.counties;
    },
    taxOffices: async function() {
      this.taxOfficeList = await repository.getAll("Accounting/getTaxOffices").then((r) => r.list);
      if (this.taxOfficeList) this.loadController.push("vd");
      return this.taxOfficeList;
    },
    getCustomerTags: async function() {
      this.customerTags = await repository.getAll("General/getCustomerTags").then((r) => r.list);
      return this.customerTags;
    },
    setRating: function(rating) {
      this.$vs.notify({
        title: "Müşteri Yıldızları",
        text: `Müşteriye ${rating} puan verildi.`,
      });
    },
    //router uzerundekı ıd ıle kullanıcı verıelrıne cekıyoruz
    fetchCustomerData: async function() {
      let r = await repository.getById("Customer/getById", this.$route.params.customerId);
      if (r && r.isSuccessful) {
        this.editSelectedRowData = r.list[0];
        if (this.editSelectedRowData) this.loadController.push("user");
      } else return;

      if (!parseInt(this.editSelectedRowData.taxNumber)) this.editSelectedRowData.taxNumber = null;

      let fn = this.editSelectedRowData.firstName;
      let span = fn.indexOf("</span>");
      if (span > 0) {
        this.editSelectedRowData.firstName_span = fn.substr(0, span + 7);
        this.editSelectedRowData.firstName = fn.substr(span + 7).trim();
      }
    },
    save_changes: async function() {
      let postModel = {};
      if (!this.validateForm) return;

      if (this.editSelectedRowData.phone == null && this.editSelectedRowData.phone2 == null && this.editSelectedRowData.isOnlineCustomer == false) {
        this.$vs.notify({
          color: "danger",
          title: "Hata",
          text: "Hatalı telefon numarası",
        });
        if (!this.editSelectedRowData.isOnlineCustomer) return;
      }

      //some other data to make suitable for db
      this.editSelectedRowData.billingCountry = (this.selectedCountry && this.selectedCountry.id) || -1;
      this.editSelectedRowData.billingCity = (this.selectedCity && this.selectedCity.id) || -1;
      this.editSelectedRowData.billingCounty = (this.selectedCounty && this.selectedCounty.id) || -1;

      console.log(this.editSelectedRowData);

      postModel = Object.assign({}, this.editSelectedRowData);

      let r = await repository.postEntity("Customer/edit", postModel);

      if (r.isSuccessful) {
        this.$vs.notify({
          color: "success",
          icon: "done",
          title: "Tamamlandı",
          text: `"${this.editSelectedRowData.firstName}" Başarıyla düzenlendi.`,
        });
        this.$router.push("/contactsView/" + this.$route.params.customerId);
      } else if (r.hasExceptionError) {
        this.$vs.notify({
          color: "danger",
          title: "Hata",
          text: r.exceptionMessage,
        });
      } else {
        this.$vs.notify({
          color: "danger",
          title: "Hata",
          text: "Bilinmeyen bir sebepten işlem tamamlanamadı!",
        });
      }
    },
    reset_data() {
      this.$router.push("/contactsView/" + this.$route.params.customerId);
    },
    update_avatar(event) {
      let selectedPic = event.target.files[0];

      this.picture = selectedPic.name;
    },
  },
};
</script>

<style scoped>
.vs__dropdown-menu {
  max-height: 200px;
}
.vue-star-rating-rating-text {
  display: none;
}
.style-chooser .vs__dropdown-toggle {
  height: 25px;
}
.style-chooser .vs__selected {
  height: 15px;
}
.style-chooser .vs__search {
  height: 15px !important;
}
</style>
